import React from 'react';
import { Alert, AlertIcon, Text } from '@chakra-ui/react';

/**
 * Aviso inline com cores EXPLÍCITAS, sem colorScheme.
 *
 * POR QUE ESTE COMPONENTE EXISTE
 *   O tema do projeto redefine os tons 100 como cores de MARCA saturadas:
 *   blue.100 = #0062FF, orange.100 = #FF6700. O variant subtle do Chakra usa o
 *   tom 100 como FUNDO, esperando um tint claro. Resultado: alerta de info com
 *   fundo azul forte e texto escuro em cima — ilegível.
 *
 *   Esta é a QUARTA vez que a mesma armadilha aparece neste painel:
 *     EG-40: red.100 guardava um VERDE, e todo alerta de erro saía verde
 *            (corrigido no theme.js, com comentário);
 *     EG-41: Tag com variant subtle em RotuloClassificacao.jsx:36, resolvido
 *            com cor explícita e comentado;
 *     esg-starter/index.jsx:165: Alert de info com bg e color inline;
 *     EG-42: os avisos da estrutura derivada.
 *
 *   Em vez de um quinto contorno local, o contorno passa a ter um lugar. Não
 *   mexi no tema global: os status error e success dependem de tons que a EG-40
 *   já ajustou, e repintá-los para consertar info/warning trocaria um defeito
 *   por outro.
 *
 *   A causa raiz continua sendo a paleta — tom 100 como cor de marca num slot
 *   que o Chakra trata como tint. Isso é decisão de design system e merece
 *   ticket próprio; este componente só impede a quinta ocorrência.
 */

const TONS = {
  info: { bg: '#E7F1FA', color: '#0A4D7A' },
  warning: { bg: '#FEF3E2', color: '#8A5300' },
};

export default function AvisoInline({
  tom = 'info',
  children,
  borderRadius = '4px',
  ...resto
}) {
  const { bg, color } = TONS[tom] ?? TONS.info;

  return (
    <Alert
      status={tom}
      borderRadius={borderRadius}
      bg={bg}
      color={color}
      {...resto}
    >
      <AlertIcon color={color} />
      <Text fontSize='sm'>{children}</Text>
    </Alert>
  );
}
